import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";
import {
    fetchAdvancedTypes,
    fetchBankAccounts,
    fetchBuysGeneralSettings, fetchCheques,
    fetchInitialSuppliers,
    fetchPOS,
    fetchSupplierPaymentData,
    fetchSuppliers,
} from "../../../../_apis/api";
import {useDispatch, useSelector} from "react-redux";
import {
    expandSearch,
    getDefaultOptionByValue,
    getModeByInstallation,
    getNumberByInstallation,
    getOptionsByData,
    getPreNumberByInstallation,
    getSelectedInstallation,
    getSelectedPreNumbers, isEmpty,
    removeDuplicateObjects,
} from "../../../../_helpers/commonFunctions";
import "react-datepicker/dist/react-datepicker.css";
import {setSaveSupplierPayments} from "../../../../_reducers/activitySlice";
import {getLabelByValue, getObjectFromArrayOfObjects,} from "../../../../_helpers/helperFunctions";
import {
    setAutoSupplierPaymentData,
    setNewSupplierPayment
} from "../../../../_reducers/DataPanel/Suppliers/supplierSlice";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import EditableTable from "../../../primer/Editable-Table";
import {toast} from "react-toastify";
import {preNumberGreek} from "../../../../_data/settings/advanced-types-search";
import AccountingBox from "../../../primer/AccountingBox";
import DateBox from "../../../primer/DateBox";
import moment from "moment";
import TextArea from "../../../common/TextArea";
import axios from "axios";
import {useTranslation} from "../../../../hooks/useTranslation";

const SupplierPaymentsNew = ({lockPaymentType = false, lockDocumentType = false}) => {
    const {t} = useTranslation();
    const [showPaymentTypeConfirmation, setShowPaymentTypeConfirmation] = useState(false);
    const [paymentTypeTempData, setPaymentTypeTempData] = useState({});
    const [showErrors, setShowErrors] = useState(false);
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const SUPPLIERS_DATA = useSelector((state) => state.SUPPLIERS_DATA);
    const saveSupplierPayments = useSelector((state) => state.ACTIVITY.saveSupplierPayments);
    const advancedTypes = useSelector((state) => state.SETTINGS.settings.advancedTypes);
    const buysGeneralSettings = useSelector((state) => state.BUYS_SETTINGS.buysGeneralSettings);
    const posList = useSelector((state) => state.CASH_DATA.posList);
    const bankAccounts = useSelector((state) => state.CASH_DATA.bankAccounts);
    const chequeList = useSelector((state) => state.CASH_DATA.chequeList);
    const cardList = useSelector((state) => state.CASH_DATA.cardList);
    const autoSupplierPaymentData = useSelector((state) => state.SUPPLIERS_DATA.autoSupplierPaymentData);

    const initialChequeDetails = [{
        _id: "",
        no: "1",
        id: "1",
        numbering: "",
        amount: 0,
    }]

    const availableCheques =
        (SUPPLIERS_DATA.newSupplierPayment.paymentTypeType === "cheque" && SUPPLIERS_DATA.newSupplierPayment.supplier) ?
            chequeList.filter((el) => el.entityId === SUPPLIERS_DATA.newSupplierPayment.supplier && el.entityType === "supplier" && !el.used).map((o) => {
                return {
                    ...o,
                    issueDate: moment(o.issueDate).format("DD/MM/YYYY"),
                    expiryDate: moment(o.expiryDate).isValid() ? moment(o.expiryDate).format("DD/MM/YYYY") : "-",
                }
            })
            : [];

    let selectedClintData = [];

    let suppliersListData = SUPPLIERS_DATA.suppliers.slice();
    const requestData = {
        company: company.id,
        year: company.year.toString(),
    };
    let requestDataF = {
        company: company.id,
        year: company.year.toString(),
        name: ''
    };
    const requestData2 = {
        company: company.id,
        year: company.year.toString(),
        isActive: "active"
    };
    // Options for Document Type Dropdown
    const supplierPaymentsDT = getObjectFromArrayOfObjects(advancedTypes, "Supplier Payments", "section");
    const documentTypesOptions = getOptionsByData(supplierPaymentsDT, "_id", "name");
    const [preNumberGreekOptions, setPreNumberGreekOptions] = useState([]);
    let selectedDocumentTypeData = [];
    let dtInstallationsOptions = [];

    const loadUnpaidBuys = (keyword, setData) => {
        axios.get(process.env.REACT_APP_API_URL2 + `/supplier/get-unpaid-list`, {
            params: {
                company: company.id,
                documentId: SUPPLIERS_DATA.newSupplierPayment.documentType,
                supplierId: SUPPLIERS_DATA.newSupplierPayment.supplier,
                installation: SUPPLIERS_DATA.newSupplierPayment.installation,
                keyword: keyword
            }}).then(res => {
            if (res.data && res.data.data && res.data.status === '200') {
                let tArr = [];
                res.data.data.forEach((buy) => {
                    tArr.push({
                        number: buy.number.replace("noprefix", ""),
                        totalAmount: buy.totalAmount,
                        paymentRemainder: buy.paymentRemainder,
                        documentTypeName: buy.documentTypeName,
                        date: moment(buy.date).format("DD-MM-YYYY HH:mm"),
                        value: String(buy._id),
                    })
                })
                setData(tArr);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const [defaultForBuyData, setDefaultForBuyData] = useState([]);
    useEffect(() => {
        if (SUPPLIERS_DATA.newSupplierPayment.supplier && SUPPLIERS_DATA.newSupplierPayment.installation) {
            loadUnpaidBuys(null, setDefaultForBuyData);
        }
    }, [SUPPLIERS_DATA.newSupplierPayment.supplier])

    useEffect(() => {
        dispatch(fetchAdvancedTypes(requestData));
        dispatch(fetchSupplierPaymentData(requestData));
        dispatch(fetchBuysGeneralSettings(requestData2));
        dispatch(fetchPOS(requestData2));
        dispatch(fetchBankAccounts(requestData2));
        dispatch(fetchCheques(requestData));
        dispatch(fetchInitialSuppliers(requestData));
    }, []);

    useEffect(() => {
        if (autoSupplierPaymentData) {
            dispatch(setAutoSupplierPaymentData(null));
            let prepObj = {...SUPPLIERS_DATA.newSupplierPayment};
            if (autoSupplierPaymentData.documentType) {
                prepObj = handleOnChange({value: autoSupplierPaymentData.documentType}, "dd", "documentType", prepObj);
            }
            dispatch(setNewSupplierPayment({...prepObj}));
        }
    }, [autoSupplierPaymentData]);

    useEffect(() => {
        if (SUPPLIERS_DATA.newSupplierPayment.installation !== undefined && SUPPLIERS_DATA.newSupplierPayment.installation !== '') {
            let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, SUPPLIERS_DATA.newSupplierPayment.installation);
            setPreNumberGreekOptions(newPreNumbers);
        }
    }, []);

    useEffect(() => { //for template
        if (SUPPLIERS_DATA.newSupplierPayment.installation !== undefined && SUPPLIERS_DATA.newSupplierPayment.installation !== '') {
            let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, SUPPLIERS_DATA.newSupplierPayment.installation);
            setPreNumberGreekOptions(newPreNumbers);
        }
    }, [SUPPLIERS_DATA.newSupplierPayment.installation]);
    const paymentTypeOptions = getOptionsByData(buysGeneralSettings.paymentTypes?.filter((el) => el.type !== "credit"), "_id", "name");
    let disabledFields = false;
    if (
        SUPPLIERS_DATA.newSupplierPayment.documentType === undefined ||
        SUPPLIERS_DATA.newSupplierPayment.documentType === ""
    ) {
        disabledFields = true;
    } else {
        let dtData = getObjectFromArrayOfObjects(
            supplierPaymentsDT,
            SUPPLIERS_DATA.newSupplierPayment.documentType,
            "_id"
        );
        if (dtData.length > 0) {
            selectedDocumentTypeData = dtData["0"];
            dtInstallationsOptions = getOptionsByData(selectedDocumentTypeData['documentNumbering'], "installationMasterId", "installation");
            dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
        }
    }
    const handlePaymentTypeConfirmation = () => {
        // Populate Selected Category Data
        let newSupplierPaymentData = {};
        let type = paymentTypeTempData.type;
        newSupplierPaymentData.paymentType = paymentTypeTempData.paymentType;
        newSupplierPaymentData.paymentTypeName = paymentTypeTempData.name;
        newSupplierPaymentData.paymentTypeType = type;
        if (type === "cash" || type === "iris") {
            newSupplierPaymentData.posDetails = SUPPLIERS_DATA.newSupplierPaymentInitialValue.posDetails;
            newSupplierPaymentData.bankDetails = SUPPLIERS_DATA.newSupplierPaymentInitialValue.bankDetails;
        }
        if (type === "pos") {
            newSupplierPaymentData.amount = "";
            newSupplierPaymentData.bankDetails = SUPPLIERS_DATA.newSupplierPaymentInitialValue.bankDetails;
        }
        if (type === "bank-account" || type === "web-banking" || type === "bank-account-outside") {
            newSupplierPaymentData.amount = "";
            newSupplierPaymentData.posDetails = SUPPLIERS_DATA.newSupplierPaymentInitialValue.posDetails;
        }
        dispatch(
            setNewSupplierPayment({
                ...SUPPLIERS_DATA.newSupplierPayment,
                ...newSupplierPaymentData,
            })
        );
        setShowPaymentTypeConfirmation(false);
    };

    const handleOnChange = (e, type = "default", ddname = "", currentState) => {
        setShowErrors(true);
        if (!saveSupplierPayments) dispatch(setSaveSupplierPayments(true));

        let name;
        let value;

        let buysData = Object.assign({}, currentState ? currentState : SUPPLIERS_DATA.newSupplierPayment);
        let newSupplierPaymentData = {};

        if (type === "dd") {
            value = e.value;
            name = ddname;
        } else if (type === 'ac') {
            value = e.target.value;
            name = ddname;
        } else if (type === "dp") {
            value = e;
            name = ddname;
        } else if (type === "acdd") {
            if (ddname === "chequeSelection") {
                const chequeData = e.row;
                newSupplierPaymentData["chequeDetails"] = [{
                    _id: chequeData._id,
                    no: "1",
                    id: "1",
                    amount: chequeData.amount,
                    numbering: chequeData.numbering,
                }]
                newSupplierPaymentData["amount"] = chequeData.amount;
            } else {
                selectedClintData = []
                e = e.row;
                selectedClintData.push(e)
                value = e._id;
                name = ddname;
            }
        } else if (type === "acdd2") {
            value = e.row.value;
            name = "forBuy";
        } else if (type === "tp") {
            value = e;
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        if (name !== "paymentType") {
            newSupplierPaymentData[name] = value;
        }

        if (name === "documentType") {
            //newSupplierPaymentData.chequeDetails = [];
            newSupplierPaymentData[name] = value;
            newSupplierPaymentData.documentTypeName = getLabelByValue(documentTypesOptions, value, "value");
            let selectedDocumentTypeData = getObjectFromArrayOfObjects(supplierPaymentsDT, value, "_id");
            if (selectedDocumentTypeData.length > 0) {
                let selectedDTData = selectedDocumentTypeData["0"];
                let selectedInstallation = getSelectedInstallation(
                    selectedDTData["documentNumbering"]
                );
                if (Object.keys(selectedInstallation).length > 0) {
                    newSupplierPaymentData.installation = selectedInstallation.installationMasterId;
                    newSupplierPaymentData.preNumber = selectedInstallation.preNumber;
                    newSupplierPaymentData.number = selectedInstallation.number + 1;
                    newSupplierPaymentData.installationMode = selectedInstallation.numberingMode;
                    newSupplierPaymentData.numberingMode = selectedInstallation.numberingMode;
                }
                if (!lockPaymentType) {
                    newSupplierPaymentData.paymentType = selectedDTData.proposedPaymentType;
                    newSupplierPaymentData.paymentTypeName = selectedDTData.proposedPaymentTypeName;
                    newSupplierPaymentData.paymentTypeType = selectedDTData.proposedPaymentTypeType;
                    if (selectedDTData.proposedPosBankAccount !== undefined && selectedDTData.proposedPosBankAccount !== "") {
                        if (posList.length > 0 || bankAccounts.length > 0) {
                            if (selectedDTData.proposedPaymentTypeType === "pos") {
                                const selectedPos = posList.filter(pos => pos._id === selectedDTData.proposedPosBankAccount)[0];
                                if (selectedPos) {
                                    let selectedPosDetails = {
                                        _id: selectedPos._id,
                                        id: "1",
                                        no: "1",
                                        name: selectedPos.name,
                                        registrationNumber: selectedPos.serialNumber,
                                        amount: 0,
                                        notes: ""
                                    }
                                    newSupplierPaymentData.posDetails = [];
                                    newSupplierPaymentData.posDetails.push(selectedPosDetails);
                                }
                            } else if ((selectedDTData.proposedPaymentTypeType === "bank-account" || selectedDTData.proposedPaymentTypeType === "web-banking" || selectedDTData.proposedPaymentTypeType === "bank-account-outside") && !lockPaymentType) {
                                const selectedBank = bankAccounts.filter(bank => bank._id === selectedDTData.proposedPosBankAccount)[0];
                                if (selectedBank) {
                                    let selectedBankDetails = {
                                        _id: selectedBank._id,
                                        id: "1",
                                        no: "1",
                                        name: selectedBank.name,
                                        accountNumber: selectedBank.iban,
                                        amount: 0,
                                        notes: ""
                                    }
                                    newSupplierPaymentData.bankDetails = [];
                                    newSupplierPaymentData.bankDetails.push(selectedBankDetails);
                                }
                            }
                        }
                    }
                }
                // newSupplierPaymentData.bankDetails[0] = selectedDTData.proposedPosBankAccount;
            }
            let p = newSupplierPaymentData.preNumber;
            // This will pre number given in document number table
            let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData["documentNumbering"], preNumberGreek);
            newPreNumbers = newPreNumbers.flatMap((item) => {
                if (p !== item.value) {
                    return []
                } else {
                    return item
                }
            });
            setPreNumberGreekOptions(newPreNumbers);
        } else if (name === "date") {
            newSupplierPaymentData.date = value;
        } else if (name === 'installation') {
            newSupplierPaymentData.installation = value;
            newSupplierPaymentData.preNumber = getPreNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            newSupplierPaymentData.installationMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            newSupplierPaymentData.numberingMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
            newSupplierPaymentData.number = getNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId') + 1;
            let p = newSupplierPaymentData.preNumber;
            // This will pre number given in document number table
            let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData["documentNumbering"], preNumberGreek);
            newPreNumbers = newPreNumbers.flatMap((item) => {
                if (p !== item.value) {
                    return []
                } else {
                    return item
                }
            });
            setPreNumberGreekOptions(newPreNumbers);
        } else if (name === "supplier") {
            // populating supplier values on the buys form
            let selectedSupplier = getObjectFromArrayOfObjects(suppliersListData, value, "_id");
            if (selectedSupplier.length === 0) {
                selectedSupplier = [...selectedClintData]
            }
            if (selectedSupplier.length > 0) {
                let sSupplier = selectedSupplier["0"];
                newSupplierPaymentData.supplierName = sSupplier.name;
                newSupplierPaymentData.supplierCode = sSupplier.systemCode; // It is the supplier code
                newSupplierPaymentData.address = sSupplier.address;
                newSupplierPaymentData.vatNumber = sSupplier.vatNumber;
                newSupplierPaymentData.doy = sSupplier.DOY;
                newSupplierPaymentData.city = sSupplier.city;
                newSupplierPaymentData.pc = sSupplier.postalCode;
                newSupplierPaymentData.country = sSupplier.country;
                newSupplierPaymentData.phone = sSupplier.phone;
                newSupplierPaymentData.email = sSupplier.email.replaceAll("mailto:", "");
            }
        } else if (name === "paymentType") {
            let paymentTypesData = getObjectFromArrayOfObjects(buysGeneralSettings.paymentTypes, value, "_id");
            if (paymentTypesData && paymentTypesData.length > 0) {
                // Show warning before change
                if (buysData.paymentType !== "" && buysData.paymentType !== undefined && buysData.paymentTypeType !== paymentTypesData["0"].type) {
                    setShowPaymentTypeConfirmation(true);
                    let paymentTypeName = getLabelByValue(paymentTypeOptions, value, "value");
                    setPaymentTypeTempData({
                        name: paymentTypeName,
                        paymentType: value,
                        type: paymentTypesData["0"].type,
                    });
                } else {
                    newSupplierPaymentData[name] = value;
                    newSupplierPaymentData.paymentTypeName = getLabelByValue(paymentTypeOptions, value, "value");
                    newSupplierPaymentData.paymentTypeType = paymentTypesData["0"].type;
                }
            }
        } else if (name === "forBuy") {
            newSupplierPaymentData.forBuyInputLabel = e.row.documentTypeName + " " + e.row.number;
        }

        if (["documentType", "client", "paymentType"].includes(name)) newSupplierPaymentData.chequeDetails = initialChequeDetails;

        if (currentState) {
            return {...buysData, ...newSupplierPaymentData};
        } else {
            dispatch(setNewSupplierPayment({...buysData, ...newSupplierPaymentData}));
        }
    }

    const supplierDropdownColumns = [
        {
            label: t("General.code"),
            name: "systemCode",
        },
        {
            label: t("General.name"),
            name: "name",
        },
        {
            label: t("General.phone"),
            name: "phone",
        },
        {
            label: t("General.email"),
            name: "email",
        },
    ];

    const posFieldColumns = [
        {
            label: t("General.name"),
            name: "name",
        },
        {
            label: t("General.serialNumber"),
            name: "serialNumber",
        },
        {
            label: "Αριθμός κάρτας",
            name: "numbering",
        },
    ];

    const bankFieldColumns = [
        {
            label: t("General.name"),
            name: "name",
        },
        {
            label: t("General.bankName"),
            name: "bankName",
        },
        {
            label: t("General.iban"),
            name: "iban",
        },
    ];

    const posColumns = [
        {
            name: t("General.name"),
            field: "name",
            editable: true,
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => {
                        const arr = [...cardList, ...posList].filter((el) => expandSearch(keyword).test(el.name));
                        setData(arr);
                    },
                    excludeColumns: [],
                    columns: posFieldColumns,
                    data: [...cardList, ...posList],
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε POS/Κάρτα",
                    disabled: lockPaymentType,
                },
                type: "advanced-combobox",
            },
        },
        {
            name: "Σειριακός Αριθμός / Αριθμός κάρτας",
            field: "registrationNumber",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t("General.amount"),
            field: "amount",
            editable: true,
            inputType: {
                type: "accounting",
                config: {
                    suffix: "€",
                    maxLength: 10,
                },
            },
        },
        {
            name: t("General.notes"),
            field: "notes",
            editable: true,
            inputType: {
                type: "text",
            },
        },
    ];

    const bankAccountColumns = [
        {
            name: t("General.name"),
            field: "name",
            editable: true,
            inputType: {
                config: {
                    onChangeSearchCell: (_, keyword, setData) => {
                        setData(bankAccounts?.filter((el) => expandSearch(keyword).test(el.name)))
                    },
                    excludeColumns: [],
                    columns: bankFieldColumns,
                    data: bankAccounts,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Select Bank",
                    disabled: lockPaymentType,
                },
                type: "advanced-combobox",
            },
        },
        {
            name: t("General.iban"),
            field: "accountNumber",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t("General.amount"),
            field: "amount",
            editable: true,
            inputType: {
                type: "accounting",
                config: {
                    suffix: "€",
                    maxLength: 10,
                },
            },
        },
        {
            name: t("General.notes"),
            field: "notes",
            editable: true,
            inputType: {
                type: "text",
            },
        },
    ];

    const posDetailsActions = {
        insert: () => {},
        update: (data, id) => {
            if (!saveSupplierPayments) dispatch(setSaveSupplierPayments(true));

            if (data.name && data.name === "") {
                toast.error("Name is mandatory field.");
            } else {
                let cpPosDetails = SUPPLIERS_DATA.newSupplierPayment.posDetails.slice();
                let foundPos = cpPosDetails.find((item) => item.id === id);
                if (foundPos !== undefined) {
                    let rowPosDetail = [];
                    // special case update name by name
                    if (data.name && data.name !== "") {
                        rowPosDetail = getObjectFromArrayOfObjects([...cardList, ...posList], data.name, "name");
                    }
                    // Field auto population on change product
                    if (rowPosDetail.length > 0) {
                        let rowPosDetailData = rowPosDetail["0"];
                        data._id = rowPosDetailData._id;
                        data.name = rowPosDetailData.name;
                        if (rowPosDetailData.isCard) { // Is card
                            data.registrationNumber = rowPosDetailData.numbering;
                            data.isCard = true;
                        } else {
                            data.registrationNumber = rowPosDetailData.serialNumber;
                            data.isCard = undefined;
                        }
                    }
                    // Updated selected product with updated field data.
                    foundPos = {...foundPos, ...data};
                    const updateCpPos = {...cpPosDetails[id - 1], ...foundPos};
                    cpPosDetails[id - 1] = updateCpPos;
                    let innerData = {...SUPPLIERS_DATA.newSupplierPayment};
                    innerData.amount = updateCpPos.amount
                    dispatch(setNewSupplierPayment({...innerData, posDetails: cpPosDetails}));
                }
            }
        },
        selected: () => {},
        delete: () => {},
    }

    const bankDetailsActions = {
        insert: () => {},
        update: (data, id) => {
            // Set if editing the form
            if (!saveSupplierPayments) dispatch(setSaveSupplierPayments(true));

            if (data.name && data.name === "") {
                toast.error("Name is mandatory field.");
            } else {
                let cpBankDetails = SUPPLIERS_DATA.newSupplierPayment.bankDetails.slice();
                let foundBank = cpBankDetails.find((item) => item.id === id);
                if (foundBank !== undefined) {
                    let rowBankDetail = [];
                    if (data.name && data.name !== "") {
                        rowBankDetail = getObjectFromArrayOfObjects(bankAccounts, data.name, "name");
                    }
                    // Field auto population on change product
                    if (rowBankDetail.length > 0) {
                        let rowBankDetailData = rowBankDetail["0"];
                        data._id = rowBankDetailData._id;
                        data.name = rowBankDetailData.name;
                        data.accountNumber = rowBankDetailData.iban;
                    }
                    foundBank = {...foundBank, ...data};
                    const updateCpBank = {...cpBankDetails[id - 1], ...foundBank};
                    cpBankDetails[id - 1] = updateCpBank;
                    let innerData = {...SUPPLIERS_DATA.newSupplierPayment};
                    innerData.amount = updateCpBank.amount
                    dispatch(setNewSupplierPayment({...innerData, bankDetails: cpBankDetails}));
                }
            }
        },
        selected: () => {},
        delete: () => {},
    };

    const selectedDocumentType = getDefaultOptionByValue(
        documentTypesOptions,
        SUPPLIERS_DATA.newSupplierPayment.documentType,
        "value",
        "label",
        "value"
    );
    const onChangeSearch = (keyword, setData) => {
        requestDataF.name = keyword

        if (keyword.length >= 2) {
            (dispatch(fetchSuppliers(requestDataF, setData)))
        }
    }
    const selectDocumentInstallation = getDefaultOptionByValue(dtInstallationsOptions, SUPPLIERS_DATA.newSupplierPayment.installation, "value", "label", "value");
    const selectedPaymentType = getDefaultOptionByValue(paymentTypeOptions, SUPPLIERS_DATA.newSupplierPayment.paymentType, "value", "label", "value");

    const isInvulnerable = false;
    const clearForBuy = () => {
        if (!saveSupplierPayments) dispatch(setSaveSupplierPayments(true));
        dispatch(setNewSupplierPayment({...SUPPLIERS_DATA.newSupplierPayment, forBuy: "", forBuyInputLabel: ""}));
    }

    return (
        <div className="new-buys client-form product-form position-relative">
            {disabledFields && (
                <div className="overlay_w">{t('SalesClientPaymentsNew.message')}</div>
            )}
            <Row className="border-bottom mb-3">
                <Col sm={12} md={3} className="showWithOverlay">
                    <Dropdown
                        label={t("General.documentType")}
                        key={Math.random()}
                        defaultValue={selectedDocumentType}
                        required={true}
                        name="documentType"
                        options={documentTypesOptions}
                        disabled={lockDocumentType}
                        onChange={(e) => handleOnChange(e, "dd", "documentType")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="3" className={"mb-3"}>
                    <DateBox
                        classes="w-100"
                        label={t("General.date")}
                        name="date"
                        selected={moment(SUPPLIERS_DATA.newSupplierPayment.date).isValid() ? new Date(SUPPLIERS_DATA.newSupplierPayment.date) : null}
                        onChange={(e) => handleOnChange(e, 'dp', 'date')}
                    />
                    {isEmpty(SUPPLIERS_DATA.newSupplierPayment.date) && <div className={"text-danger"}>Απαιτείται Ημερομηνία.</div>}
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={3} className="mb-2">
                    <div className="mb-3">
                        <Dropdown
                            label={t("General.installation")}
                            options={dtInstallationsOptions}
                            value={Object.keys(selectDocumentInstallation).length !== 0 ? selectDocumentInstallation : ''}
                            enabledValue={true}
                            required={true}
                            name="installation"
                            classes="w-100"
                            onChange={(e) => handleOnChange(e, "dd", "installation")}
                        />
                        {showErrors &&
                            SUPPLIERS_DATA.newSupplierPayment.installation === "" && (
                                <div className="text-danger">{t("Required.installation")}</div>
                            )}
                    </div>
                </Col>
                <Col sm="12" md="3">
                    <div className="mb-3">
                        <Dropdown
                            label={t("General.preNumber")}
                            name="preNumber"
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(
                                preNumberGreekOptions,
                                SUPPLIERS_DATA.newSupplierPayment.preNumber,
                                "value",
                                "label",
                                "value"
                            )}
                            options={preNumberGreekOptions}
                            disabled={SUPPLIERS_DATA.newSupplierPayment.numberingMode === "manual"}
                            onChange={(e) => handleOnChange(e, "dd", "preNumber")}
                        />
                    </div>
                </Col>
                <Col sm="12" md="3">
                    <Input
                        className="mb-3 w-100"
                        label={t("General.number")}
                        name="number"
                        value={SUPPLIERS_DATA.newSupplierPayment.number}
                        placeholder="Number"
                        onChange={(e) => handleOnChange(e)}
                        disabled={SUPPLIERS_DATA.newSupplierPayment.numberingMode !== "manual"}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={3} className="mb-2">
                    <Dropdown
                        label={t("General.paymentType")}
                        options={paymentTypeOptions}
                        value={Object.keys(selectedPaymentType).length !== 0 ? selectedPaymentType : ''}
                        enabledValue={true}
                        name="paymentType"
                        searchEnable={true}
                        disabled={lockPaymentType}
                        onChange={(e) => handleOnChange(e, "dd", "paymentType")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={3} className="mb-2">
                    <AdvancedCombobox
                        ACName="Supplier Payment Supplier" // do not change name
                        className="w-100 ac-select-dropdown"
                        defaultValue={SUPPLIERS_DATA.newSupplierPayment.supplierName}
                        key={Math.random()}
                        label={t("General.supplier")}
                        data={suppliersListData}
                        onChange={(e) => {
                            handleOnChange(e, "acdd", "supplier");
                        }}
                        onChangeSearch={onChangeSearch}
                        excludeColumns={[]}
                        columns={supplierDropdownColumns}
                        deleteEnable={false}
                        searchTableEnable={false}
                        showTableOptionOnSelect={true}
                        placeholder={t("Placeholders.selectSupplier")}
                        required={true}
                        showInsertAddButton={true}
                        hideSaveButton={true}
                        hideInsertNewRow={true}
                    />
                    {showErrors && SUPPLIERS_DATA.newSupplierPayment.supplier === "" && (
                        <div className="text-danger">{t("Required.supplier")}</div>
                    )}
                </Col>
                <Col sm="12" md="3">
                    <div className="mb-3">
                        <Input
                            className="w-100"
                            label={t("General.vatNumber")}
                            name="vat"
                            value={SUPPLIERS_DATA.newSupplierPayment.vatNumber}
                            onChange={(e) => handleOnChange(e)}
                            disabled={true}
                            readonly
                        />
                    </div>
                </Col>
                <Col sm="12" md="3">
                    <div className="d-flex">
                        <Input
                            label={t("General.address")}
                            className="w-100"
                            name="address"
                            value={SUPPLIERS_DATA.newSupplierPayment.address}
                            onChange={(e) => handleOnChange(e)}
                            disabled={true}
                            readonly
                        />
                    </div>
                </Col>
                <Col sm="12" md="3">
                    <div className="d-flex">
                        <Input
                            label={t("General.country")}
                            className="w-100"
                            name="country"
                            value={SUPPLIERS_DATA.newSupplierPayment.country}
                            onChange={(e) => handleOnChange(e)}
                            disabled={true}
                            readonly
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="3">
                    <div className="d-flex">
                        <Input
                            label={t("General.phone")}
                            className="w-100"
                            name="phone"
                            value={SUPPLIERS_DATA.newSupplierPayment.phone}
                            onChange={(e) => handleOnChange(e)}
                            disabled={true}
                            readonly
                        />
                    </div>
                </Col>
                <Col sm="12" md="3">
                    <div className="d-flex">
                        <Input
                            label={t("General.email")}
                            className="w-100"
                            name="email"
                            value={SUPPLIERS_DATA.newSupplierPayment.email}
                            onChange={(e) => handleOnChange(e)}
                            disabled={true}
                            readonly
                        />
                    </div>
                </Col>
                <Col md={3}>
                    <AdvancedCombobox
                        className="w-100 ac-select-dropdown"
                        label={"Αφορά την αγορά"}
                        placeholder={"Προσθέστε αγορά"}
                        defaultValue={SUPPLIERS_DATA.newSupplierPayment?.forBuyInputLabel}
                        data={defaultForBuyData}
                        onChange={(e) => handleOnChange(e, "acdd2")}
                        excludeColumns={[]}
                        columns={[
                            {label: "Ημερομηνία", name: "date"},
                            {label: "Τύπος Παραστατικού", name: "documentTypeName"},
                            {label: "Αρίθμηση", name: "number"},
                            {label: "Πληρωτέο Ποσό", name: "totalAmount"},
                            {label: "Υπολ. Ποσό", name: "paymentRemainder"},
                        ]}
                        deleteEnable={false}
                        searchTableEnable={false}
                        showTableOptionOnSelect={true}
                        key={Math.random()}
                        disabled={!SUPPLIERS_DATA.newSupplierPayment.installation || !SUPPLIERS_DATA.newSupplierPayment.supplier || String(SUPPLIERS_DATA.newSupplierPayment.forBuy).length === 24}
                        onChangeSearch={(keyword, setData) => loadUnpaidBuys(keyword, setData)}
                    />
                </Col>
                <Col md={3} hidden={isInvulnerable}>
                    {String(SUPPLIERS_DATA.newSupplierPayment?.forBuy).length === 24 &&
                        <button style={{position: "absolute", bottom: "13px"}} className="btn btn-sm" title="Καθαρισμός επιλεγμένης αγοράς" onClick={() => clearForBuy()}><i className="fas fa-xmark"></i></button>
                    }
                </Col>
            </Row>
            <br/>
            <Row>
                <Col md={12}>
                    <Input
                        label={t("General.reason")}
                        className="w-100 mb-3"
                        name="reason"
                        value={SUPPLIERS_DATA.newSupplierPayment.reason}
                        onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            </Row>

            {(SUPPLIERS_DATA.newSupplierPayment.paymentTypeType === "cash" || SUPPLIERS_DATA.newSupplierPayment.paymentTypeType === "iris") && (
                <Row>
                    <Col sm="12" md="4">
                        <div className="mb-3">
                            <div className={"mb-1"}>{t("General.paymentAmount")}</div>
                            <AccountingBox
                                name="amount"
                                label={t("General.paymentAmount")}
                                placeholder={t("General.paymentAmount")}
                                defaultValue={SUPPLIERS_DATA.newSupplierPayment.amount}
                                key={SUPPLIERS_DATA.newSupplierPayment.amount}
                                onBlur={(e) => handleOnChange(e, 'ac', 'amount')}
                            />
                        </div>
                    </Col>
                </Row>
            )}

            {(SUPPLIERS_DATA.newSupplierPayment.paymentTypeType === "bank-account" || SUPPLIERS_DATA.newSupplierPayment.paymentTypeType === "web-banking" || SUPPLIERS_DATA.newSupplierPayment.paymentTypeType === "bank-account-outside") && (
                <div className="bank-data">
                    <div className="text-muted mb-2">
                        <i>{t("General.bankAccountData")}</i>
                    </div>
                    <EditableTable
                        reqName="bank"
                        key={Math.random()}
                        tableName="Supplier Payment Bank Account Data Table" // do not change name
                        allowToggleColumns={true}
                        allowActions={true}
                        allowInsertRow={false}
                        allowPagination={false}
                        allowBulkDelete={false}
                        allowSorting={false}
                        allowSelectionCheckbox={false}
                        columns={bankAccountColumns}
                        allowPrintResults={false}
                        enableNewRowCheckbox={true}
                        onUpdate={bankDetailsActions}
                        data={SUPPLIERS_DATA.newSupplierPayment.bankDetails}
                    />
                </div>
            )}

            {SUPPLIERS_DATA.newSupplierPayment.paymentTypeType === "pos" && (
                <div className="pos-data">
                    <div className="text-muted mb-2">
                        <i>{t("General.posData")}</i>
                    </div>
                    <EditableTable
                        reqName="pos"
                        key={Math.random()}
                        tableName="Supplier Payment POS Data Table" // do not change name
                        allowToggleColumns={true}
                        allowActions={true}
                        allowInsertRow={false}
                        allowPagination={false}
                        allowBulkDelete={false}
                        allowSorting={false}
                        allowSelectionCheckbox={false}
                        columns={posColumns}
                        enableNewRowCheckbox={true}
                        allowPrintResults={false}
                        onUpdate={posDetailsActions}
                        data={SUPPLIERS_DATA.newSupplierPayment.posDetails}
                    />
                </div>
            )}

            {SUPPLIERS_DATA.newSupplierPayment.paymentTypeType === "cheque" && (
                <div className="cheque-data">
                    <Row>
                        <Col md={9} className={"mb-3"}>
                            <AdvancedCombobox
                                name="chequeSelection"
                                className="w-100 ac-select-dropdown"
                                defaultValue={SUPPLIERS_DATA.newSupplierPayment.chequeDetails[0].numbering}
                                label={"Συσχετιζόμενη επιταγή"}
                                data={availableCheques}
                                key={SUPPLIERS_DATA.newSupplierPayment.chequeDetails[0]._id}
                                onChange={(e) => handleOnChange(e, "acdd", "chequeSelection")}
                                resetFilter={() => dispatch(setNewSupplierPayment({...SUPPLIERS_DATA.newSupplierPayment, chequeDetails: initialChequeDetails}))}
                                excludeColumns={[]}
                                columns={[
                                    {label: "Αριθμός Επιταγής", name: "numbering"},
                                    {label: "Ημερομηνία Έκδοσης", name: "issueDate"},
                                    {label: "Ημερομηνία Λήξης", name: "expiryDate"},
                                    {label: "Ποσό", name: "amount"},
                                ]}
                                deleteEnable={false}
                                searchTableEnable={false}
                                showTableOptionOnSelect={true}
                                placeholder={"Επιλέξτε επιταγή"}
                                required={true}
                                showInsertAddButton={true}
                                hideSaveButton={true}
                                hideInsertNewRow={true}
                                inputFieldClasses="form-control"
                            />
                        </Col>
                        {SUPPLIERS_DATA.newSupplierPayment.chequeDetails[0]._id && (
                            <Col md={3}>
                                <label>Ποσό (€)</label>
                                <AccountingBox
                                    name={"amount"}
                                    key={SUPPLIERS_DATA.newSupplierPayment.chequeDetails[0].amount}
                                    defaultValue={SUPPLIERS_DATA.newSupplierPayment.chequeDetails[0].amount}
                                    disabled={true}
                                />
                            </Col>
                        )}
                    </Row>
                </div>
            )}

            <Row>
                <Col sm="12">
                    <div className="mb-3 w-100">
                        <div className="text-muted mb-2">
                            <i>{t("General.notes")}</i>
                        </div>
                        <TextArea
                            rows="4"
                            placeholder={t("Placeholders.notes")}
                            limit="1000"
                            name="paymentNotes"
                            value={SUPPLIERS_DATA.newSupplierPayment.paymentNotes}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </div>
                </Col>
            </Row>

            <Modal backdrop={"static"} className="themeModal" show={showPaymentTypeConfirmation}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("General.warning")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t("General.warningDataLoss")}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="outline-primary"
                        onClick={() => setShowPaymentTypeConfirmation(false)}
                    >
                        {t("General.noOption")}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => handlePaymentTypeConfirmation()}
                    >
                        {t("General.yesOption")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default SupplierPaymentsNew;
